export enum StatusOption {
  Active = 'Active',
  Inactive = 'Inactive',
}

export enum DetailsFormFields {
  status = 'status',
}

export type DetailsFormValues = {
  [DetailsFormFields.status]: StatusOption;
};
